import { render } from "./TrocarSenhaModal.vue?vue&type=template&id=241a3532&scoped=true"
import script from "./TrocarSenhaModal.vue?vue&type=script&lang=js"
export * from "./TrocarSenhaModal.vue?vue&type=script&lang=js"

import "./TrocarSenhaModal.vue?vue&type=style&index=0&id=241a3532&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-241a3532"]])

export default __exports__